import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import CreditNotesTable from "@/components/invoices/credits/credit-notes-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const creditNotesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  reason: z.string().optional(),
  numericRanges: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/credit-notes/",
)({
  validateSearch: creditNotesSearchSchema,
  component: CreditNotesPage,
});

function CreditNotesPage() {
  const { t } = useTranslation(["invoices"]);
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "credit_notes", actions: ["read"] }]}
    >
      <div className="space-y-4">
        <CreditNotesTable
        currentPage={searchParams.page}
        basePath="/invoices/credit-notes"
        searchParams={searchParams}
      />
      </div>
    </RouteGuardPermissions>
  );
}
